<template>
	<div class="page-channel page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">频道管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>商品管理</el-breadcrumb-item>
							<el-breadcrumb-item>频道管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleChannel('add')">添加 <i
							class="el-icon-plus"></i></el-button>
					<el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<!--<el-form-item prop="id" label="ID：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.id" size="small" placeholder="频道ID" clearable></el-input>
                        </el-form-item>-->
						<el-form-item prop="name" label="频道名称：" style="margin-bottom: 0;">
							<el-input v-model="form_search.name" size="small" placeholder="频道名称" clearable></el-input>
						</el-form-item>
						<el-form-item prop="desk_number" label="所属店铺：">
							<el-select size="small" v-model="form_search.desk_number" placeholder="请选择"
								style="width:100%;">
								<el-option v-for="item in init_data.desk_name_list" :key="item.number"
									:label="item.name" :value="item.number">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="name" align="center" label="频道名称" min-width="120">
							</el-table-column>
							<el-table-column prop="desk_name" align="center" label="所属店铺" min-width="180">
							</el-table-column>
							<el-table-column prop="type_name" align="center" label="频道类型" min-width="120">
							</el-table-column>
							<el-table-column prop="sort" align="center" label="排序" min-width="120">
							</el-table-column>
							<el-table-column prop="status_name" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<!--<el-table-column prop="m_time" align="center" label="更新时间" min-width="180">
                            </el-table-column>
                            <el-table-column prop="c_time" align="center" label="创建时间" min-width="180">
                            </el-table-column>-->
							<el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-m" type="primary" size="mini"
										@click="$util.goTo('/goods/channelgoods',{query:{channel_id:scope.row.id,channel_name:scope.row.name}})">
										管理商品</el-button>
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="handleChannel('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini"
										@click="deleteChannel(scope.row.id)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export channel-dialog" :title="dlg_channel.title" :visible.sync="dlg_channel.visible"
			width="534px" @closed="closeChannel" :close-on-click-modal="false">
			<el-form ref="formChannel" :model="dlg_channel.form" label-width="110px" :rules="dlg_channel.rules"
				@submit.native.prevent>
				<el-form-item prop="name" style="margin-top: 15px;" label="频道名称：" :error="dlg_channel.error.name">
					<el-input size="small" v-model="dlg_channel.form.name" placeholder='请输入频道名称' clearable></el-input>
				</el-form-item>
				<el-form-item prop="desk_number" label="所属店铺：">
					<el-select size="small" v-model="dlg_channel.form.desk_number" placeholder="请选择">
						<el-option v-for="item in dlg_channel.init_data.desk_name_list" :key="item.number" :label="item.name"
							:value="item.number">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type" label="频道类型：">
					<el-select size="small" v-model="dlg_channel.form.type" placeholder="请选择">
						<el-option v-for="item in dlg_channel.init_data.type_list" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="sort" label="排序：">
					<el-input size="small" type='number' v-model="dlg_channel.form.sort" placeholder='请输入排序（输入数字）'
						clearable></el-input>
				</el-form-item>
				<el-form-item prop="status" label="状态：">
					<el-radio-group v-model="dlg_channel.form.status">
						<el-radio v-for="(item, index) in dlg_channel.init_data.status_list" :key="index"
							:label="item.id">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_channel.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitChannel()" :loading="dlg_channel.btn_loading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				//搜索
				form_search: {
					name: "",
					status: -1
				},
				init_data: {
					status_list: [{
						id: -1,
						name: '全部'
					}, {
						id: 0,
						name: '禁用'
					}, {
						id: 1,
						name: '启用'
					}],
					desk_name_list: [],
				},
				multipleSelection: [],
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 30,
						total: 130
					}
				},
				dlg_channel: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					form: {
						desk_number: '',
						name: '',
						type: 1,
						sort: '',
						status: 1
					},
					error: {
						name: ''
					},
					reset_form: {},
					init_data: {
						desk_name_list: [],
						status_list: [{
							id: 0,
							name: '禁用'
						}, {
							id: 1,
							name: '启用'
						}],
						type_list: [{
							id: 1,
							name: '精选好物'
						}, {
							id: 2,
							name: '菜单推荐'
						}, {
							id: 3,
							name: '其他'
						}]
					},
					rules: {
						desk_number: {
							required: true,
							message: '请输入店铺编码',
							trigger: ['change', 'blur']
						},
						name: {
							required: true,
							message: '请输入频道名称',
							trigger: ['change', 'blur']
						},
						type: {
							required: true,
							message: '请选择频道类型',
							trigger: ['change', 'blur']
						},
						sort: {
							required: true,
							message: '请输入排序（输入数字）',
							trigger: ['change', 'blur']
						},
						status: {
							required: true,
							message: '请选择状态',
							trigger: ['change', 'blur']
						},
					}
				}
			}
		},
		created() {
			document.title = '频道管理';
			this.dlg_channel.reset_form = Object.assign({}, this.dlg_channel.form);
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var status_list = [{
					id: -1,
					name: '全部'
				}];
				this.$client.get('/adminapi/productchannel/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.dlg_channel.init_data.desk_name_list = res.desk_name_list;
					_this.dlg_channel.init_data.status_list = res.status_name_list;
					_this.dlg_channel.init_data.type_list = res.type_name_list;
					_this.init_data.desk_name_list = status_list.concat(res.desk_name_list);
					_this.init_data.status_list = status_list.concat(res.status_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delmultiple() {
				var _this = this;
				var mullist = this.multipleSelection;
				if (mullist.length == 0) {
					_this.$message("请勾选需要删除的频道");
					return;
				}
				var idList = [];
				for (var i = 0; i < mullist.length; i++) {
					idList.push(mullist[i].id);
				}
				var params = {
					id: idList.join(",")
				}
				this.$confirm('确定要批量删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/productchannel/delete', params, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},

			handleChannel(type, data) {
				this.dlg_channel.visible = true;
				if (type == 'add') {
					this.dlg_channel.title = '添加频道';
					this.dlg_channel.api = '/adminapi/productchannel/save';
				} else {
					this.dlg_channel.id = data.id;
					this.dlg_channel.title = '编辑频道';
					if (data) {
						for (var key in this.dlg_channel.form) {
							this.dlg_channel.form[key] = data[key];
						}
					}
					this.dlg_channel.api = '/adminapi/productchannel/save?id=' + data.id;
				}
			},
			deleteChannel(id) {
				var _this = this;
				this.$confirm('确定要删除？', "", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						iconClass: "icon-delete el-icon-delete",
						customClass: "my-confirm-box",
						center: true,
					})
					.then(() => {
						_this.$client.post('/adminapi/productchannel/delete', {
							id: id
						}, function(res, message) {
							_this.getList();
						}, function(res) {

						});
					})
					.catch(() => {});
			},
			submitChannel() {
				var _this = this;
				_this.$refs['formChannel'].validate((valid) => {
					if (valid) {
						this.dlg_channel.btn_loading = true;
						this.$client.post(this.dlg_channel.api, this.dlg_channel.form, function(res, message) {
							//console.log(res)
							_this.$message(message);
							_this.getList();
							_this.dlg_channel.btn_loading = false;
							_this.dlg_channel.visible = false;
						}, function(message) {
							_this.dlg_channel.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_channel.error[key] = message[key];
								}
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeChannel() {
				for (var key in this.dlg_channel.form) {
					this.dlg_channel.form[key] = this.dlg_channel.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formChannel.clearValidate();
				})
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>

</style>
